import {saveOnboarding} from 'iq-onboarding/api';
import type {OnboardingState} from 'iq-onboarding/types';
import type {PostAuthAction} from 'iq-auth/post_auth_actions';

/**
 * Saves the user's onboarding selections after they authenticate. Used by the
 * resume → preferences signup wizard (full state) and to seed an anonymous
 * experience-submitter's preferences with the guide's company/position.
 *
 * This hits POST /v1/onboarding, a guarded create: it establishes preferences
 * for a user who has not onboarded yet and is rejected (409) once they have. It
 * does not overwrite or delete existing rows, so it's only enqueued from
 * signup-style contexts — never for an already-authenticated experience submitter.
 */
export const saveOnboardingAction: PostAuthAction<OnboardingState> = {
  key: 'iq:onboarding-state',
  run: async (payload) => {
    await saveOnboarding(payload);
  },
};
